import {Fragment, h} from 'preact';
import {formatPrice} from "../../tools";

export default function SppsServiceRow(
	{
		debt,
		account,
		amounts,
		onChangeCheckbox,
		isChecked,
		onChangeAmountInput,
		formParams,
		isCheckedPlanAccruals,
	}){

	const columnTitleClass = isChecked ? 'form-field__input-row form-field__input-row_fd_row':'';
	return (
		<div className="debt-table-item debt-table__item">
			<div className="debt-table-item__row">
				<div className="debt-table-item__col">
					<label className="checkbox debt-table-item__checkbox">
						<input className="checkbox__input" type="checkbox" onChange={onChangeCheckbox(account.id, debt.serviceId, debt.accountId)} checked={isChecked}/><span className="checkbox__label"/>
					</label>
				</div>
				<div className="debt-table-item__col">
					<div className="debt-table-item__title">{debt.serviceName}</div>
					<div className="debt-table-item__subtitle">{debt.providerName}</div>
					{
						!!debt.accountId && <div className="debt-table-item__subtitle">ЛС {debt.accountId}</div>
					}
				</div>
				<div className="debt-table-item__col">
					<div className="form-field">
						<div className="form-field__inner">
							<div className="form-field__title-row">
								<label className="form-field__title">К оплате</label>
							</div>
							{isChecked && debt.debtServiceInfo ? (
								<div className="form-field__input-row">
									<input
										className="input form-field__input"
										type="text"
										value={amounts.debt >= 0 ? formatPrice(amounts.debt):''}
										onInput={onChangeAmountInput(account.id, debt.debtServiceInfo.id, 0, debt.accountId)} autoComplete="off"
									/>
								</div>
							):(
								<div className={columnTitleClass}>
									<div className="debt-table-item__col-info">{formatPrice(amounts.debt)} р.</div>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="debt-table-item__col">
					{!!debt.fineServiceId && debt.fineAmount !== null && (
						<div className="form-field">
							<div className="form-field__inner">
								<div className="form-field__title-row">
									<label className="form-field__title">Пеня</label>
								</div>
								{isChecked && debt.fineServiceInfo && debt.fineAmount > 0 ? (
									<div className="form-field__input-row">
										<input
											className="input form-field__input"
											type="text"
											value={amounts.fine >= 0 ? formatPrice(amounts.fine):''}
											onInput={onChangeAmountInput(account.id, debt.fineServiceInfo.id, 0, debt.fineAmount)} autoComplete="off"
										/>
									</div>
								):(
									<div className={columnTitleClass}>
										<div className="debt-table-item__col-info">{formatPrice(amounts.fine)} р.</div>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
				<div className="debt-table-item__col">
					<div className="form-field prepayment-block__row-item">
						<div className="form-field__inner">
							<div className="form-field__title-row">
								<div className="form-field__title">Комиссия</div>
							</div>
							<div className={columnTitleClass}>
								<div className="debt-table-item__col-info">{formatPrice(amounts.comission)} р.</div>
							</div>
						</div>
					</div>
				</div>
				<div className="debt-table-item__col">
					<div className="form-field prepayment-block__row-item">
						<div className="form-field__inner">
							<div className="form-field__title-row">
								<div className="form-field__title">Всего</div>
							</div>
							<div className={columnTitleClass}>
								<div className="debt-table-item__col-info">{formatPrice(amounts.total)} р.</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{
				!!debt.planAccruals && (
					<div className="debt-table-item__row">
						<div className="debt-table-item__col">
							<label className="checkbox debt-table-item__checkbox">
								<input className="checkbox__input" type="checkbox" onChange={onChangeCheckbox(account.id, debt.serviceId, debt.accountId, 1)} checked={isCheckedPlanAccruals}/><span className="checkbox__label checkbox__label_debts-item"/>
							</label>
						</div>
						<div className="debt-table-item__col">
							<div className="debt-table-item__title" style={{
								color: '#505565',
								fontSize: '18px',
								marginTop: '25px',
							}}>рекомендуемая сумма к оплате</div>
							<div className="debt-table-item__subtitle">{debt.providerName}</div>
							{
								!!debt.accountId && <div className="debt-table-item__subtitle">ЛС {debt.accountId}</div>
							}
						</div>
						<div className="debt-table-item__col">
							<div className="form-field">
								<div className="form-field__inner">
									{isCheckedPlanAccruals && debt.debtServiceInfo ? (
										<div className="form-field__input-row">
											<input
												className="input form-field__input"
												type="text"
												value={amounts.plan >= 0 ? formatPrice(amounts.plan):''}
												onInput={onChangeAmountInput(account.id, debt.debtServiceInfo.id, 0, debt.accountId, 1)} autoComplete="off"
											/>
										</div>
									):(
										<div className={columnTitleClass}>
											<div className="debt-table-item__col-info">{formatPrice(debt.planAccruals)} р.</div>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="debt-table-item__col"/>
						<div className="debt-table-item__col">
							<div className={columnTitleClass}>
								<div className="debt-table-item__col-info">{formatPrice(amounts.planComission)} р.</div>
							</div>
						</div>
						<div className="debt-table-item__col"/>
					</div>
				)
			}
		</div>
	);
}
